import { Form } from 'antd';
import styled from 'styled-components';

export const FormItemDescription = styled(Form.Item)`
  margin-bottom: 64px;
`;
